export const translations = {
  en: {
    // Nav
    "nav.services": "Services",
    "nav.fleet": "Fleet",
    "nav.process": "How It Works",
    "nav.contact": "Contact",
    "nav.signin": "Sign In",
    "nav.reserve": "Reserve Now",
    "nav.dashboard": "Dashboard",
    "nav.account": "Account",
    "nav.myAccount": "My Account",
    "nav.signout": "Sign Out",
    // Landing hero
    "hero.eyebrow": "Montréal · Chauffeured Luxury Transport",
    "hero.title": "Premium Chauffeur & Group Transportation in Montréal",
    "hero.subtitle": "Reserve private chauffeur, limousine, Ford Sprinter, minibus and charter bus transportation for airport transfers, corporate travel, weddings, events and group transportation.",
    "hero.cta": "Reserve Your Ride",
    "hero.fleet": "Explore the Fleet",
    "hero.licensed": "Licensed & Insured",
    "hero.available": "24/7 Availability",
    "hero.rated": "5-Star Chauffeurs",
    "hero.call": "Call 24/7",
    "hero.phone": "438-470-1138",
    "widget.title": "Get an instant quote",
    "widget.tripType": "Trip type",
    "widget.pickup": "Pickup location",
    "widget.dropoff": "Destination",
    "widget.date": "Pickup date",
    "widget.time": "Pickup time",
    "widget.passengers": "Passengers",
    "widget.service": "Service / vehicle",
    "widget.anyService": "Any service",
    "widget.submit": "View Vehicles & Pricing",
    "trust.licensed": "Licensed & insured",
    "trust.chauffeurs": "Professional chauffeurs",
    "trust.support": "24/7 booking support",
    "trust.flight": "Flight monitoring",
    "trust.secure": "Secure online payments",
    "trust.montreal": "Montréal-based service",
    "cat.eyebrow": "Our Services",
    "cat.title": "One company for every kind of transportation",
    "cat.subtitle": "From private chauffeur service to large-group transportation across Montréal and Québec.",
    "cat.for": "Best for",
    "cat.private_driver.for": "Executive travel · Airport · Business · VIP",
    "cat.limousine.for": "Weddings · Proms · Anniversaries · Celebrations",
    "cat.party_bus.for": "Airport groups · Corporate teams · Tours · Sports teams",
    "cat.transit_bus.for": "Conferences · Schools · Large groups · Long distance",
    "cat.book": "Book now",
    "cat.quote": "Request a quote",
    "cat.capacity": "Up to {n} passengers",
    "cat.instant": "Instant booking",
    "cat.quoteOnly": "Custom quote",
    "pos.title": "One premium transportation company for everything",
    "pos.subtitle": "From private chauffeur service to large-group transportation — booked, paid and confirmed online in minutes.",
    "faq.eyebrow": "FAQ",
    "faq.title": "Frequently asked questions",
    "faq.q1": "What areas do you serve?",
    "faq.a1": "We are based in Montréal and serve Greater Montréal, Laval, Longueuil, the South and North Shores and Montréal-Trudeau Airport (YUL). Long-distance trips to Québec City, Ottawa and Toronto are available on request.",
    "faq.q2": "How do I get a price?",
    "faq.a2": "Enter your trip in the booking form to instantly see available vehicles and pricing. Group and charter requests are sent to our team for a custom quote within hours.",
    "faq.q3": "Do you monitor flights for airport pickups?",
    "faq.a3": "Yes. For airport transfers we monitor your flight and adjust pickup times for delays or early arrivals, with complimentary waiting time.",
    "faq.q4": "How do deposits and payment work?",
    "faq.a4": "Instant bookings are confirmed with a secure deposit online. The balance is due before or on the day of service. Corporate invoicing is available for approved accounts.",
    "faq.q5": "Can you handle weddings and large group events?",
    "faq.a5": "Absolutely. We coordinate multiple vehicles, multiple pickups and custom schedules for weddings, conferences, schools and sports teams. Request a custom quote and our team will build your itinerary.",
    "nav.airport": "Airport Transfers",
    "nav.corporate": "Corporate",
    "nav.weddings": "Weddings & Events",
    "nav.groups": "Group Transportation",
    "nav.areas": "Service Areas",
    "nav.about": "About",
    "nav.getQuote": "Get a Quote",
    "nav.airportShort": "Airport",
    "nav.weddingsShort": "Weddings",
    "nav.groupsShort": "Groups",
    "nav.call": "Call",
    "air.eyebrow": "Airport Transfers · YUL",
    "air.title": "Montréal-Trudeau airport transfers, done right",
    "air.subtitle": "Private chauffeur, Ford Sprinter and group airport transportation to and from Montréal-Trudeau (YUL) — with flight monitoring, meet-and-greet and complimentary waiting time.",
    "air.inc.title": "Every airport transfer includes",
    "air.inc.flight.t": "Flight monitoring",
    "air.inc.flight.d": "We track your flight and automatically adjust pickup for delays or early arrivals.",
    "air.inc.greet.t": "Meet & greet",
    "air.inc.greet.d": "Your chauffeur greets you in the terminal with a name sign and assists with luggage.",
    "air.inc.wait.t": "Complimentary waiting",
    "air.inc.wait.d": "Included waiting time after landing so you're never rushed through the terminal.",
    "air.inc.luggage.t": "Luggage assistance",
    "air.inc.luggage.d": "Ample luggage capacity and door-to-door handling for you and your group.",
    "air.inc.fixed.t": "Transparent pricing",
    "air.inc.fixed.d": "Clear airport pricing quoted up front — no surge, no surprises.",
    "air.inc.child.t": "Child seats on request",
    "air.inc.child.d": "Infant and booster seats available — just add them to your reservation.",
    "air.how.title": "How airport transfers work",
    "air.how.s1.t": "Enter your flight",
    "air.how.s1.d": "Add your flight number, terminal and passenger count when you book.",
    "air.how.s2.t": "We monitor & dispatch",
    "air.how.s2.d": "We watch your flight and send your chauffeur to meet you at the right time.",
    "air.how.s3.t": "Meet & ride",
    "air.how.s3.d": "Your chauffeur greets you, handles the luggage and drives you door to door.",
    "air.faq.title": "Airport transfer questions",
    "air.faq.q1": "What if my flight is delayed?",
    "air.faq.a1": "We monitor your flight in real time and adjust your pickup automatically at no extra charge, with included complimentary waiting time.",
    "air.faq.q2": "Where will my chauffeur meet me?",
    "air.faq.a2": "For arrivals, your chauffeur meets you inside the terminal with a name sign. Exact meeting instructions are confirmed before your trip.",
    "air.faq.q3": "Can you handle groups arriving on the same flight?",
    "air.faq.a3": "Yes — we coordinate Ford Sprinters and buses for groups of up to 33 passengers arriving together. Request a custom quote for group airport transfers.",
    "air.faq.q4": "Do you serve airports other than YUL?",
    "air.faq.a4": "Montréal-Trudeau (YUL) is our primary airport. Transfers to other airports and long-distance destinations are available on request.",
    "air.cta.title": "Reserve your airport transfer",
    "air.cta.sub": "Book a private chauffeur or request a group quote in minutes.",
    "corp.eyebrow": "Corporate Transportation",
    "corp.title": "Corporate travel, handled with precision",
    "corp.subtitle": "One dependable partner for executive travel, airport runs, roadshows and group transportation — with centralized billing and priority dispatch for your team.",
    "corp.cta": "Open a Corporate Account",
    "corp.benefits.title": "Built for teams that travel",
    "corp.b1.t": "Centralized billing",
    "corp.b1.d": "Consolidate every trip into a single monthly invoice with cost-centre breakdowns.",
    "corp.b2.t": "Monthly invoicing",
    "corp.b2.d": "Flexible billing terms and monthly statements instead of paying trip by trip.",
    "corp.b3.t": "Multiple bookers",
    "corp.b3.d": "Authorize assistants and team members to book on the company account.",
    "corp.b4.t": "Priority dispatch",
    "corp.b4.d": "Your reservations are prioritized so executives are never left waiting.",
    "corp.b5.t": "Conference & roadshow coordination",
    "corp.b5.d": "Multi-vehicle logistics for conferences, roadshows and corporate events.",
    "corp.b6.t": "Trip reporting",
    "corp.b6.d": "Detailed reporting and saved passengers, routes and cost centres.",
    "corp.form.title": "Open a corporate account",
    "corp.form.sub": "Tell us about your team and our account management will be in touch within one business day.",
    "corp.form.company": "Company name",
    "corp.form.contact": "Contact name",
    "corp.form.employees": "Approx. team / monthly trips",
    "corp.form.message": "How can we help?",
    "corp.form.submit": "Request Corporate Account",
    "corp.form.success": "Request received",
    "corp.form.successSub": "Thank you — our corporate account team will contact you shortly.",
    "wed.eyebrow": "Weddings & Events",
    "wed.title": "Wedding & event transportation, beautifully coordinated",
    "wed.subtitle": "Limousines, Ford Sprinters and guest shuttles for weddings, galas and private celebrations across Montréal — with multi-vehicle coordination and a schedule built around your day.",
    "wed.svc.title": "Wedding & event transportation services",
    "wed.s1.t": "Wedding limousine",
    "wed.s1.d": "A chauffeured limousine for the couple — grand entrances, portraits and the drive to your reception.",
    "wed.s2.t": "Ford Sprinter transportation",
    "wed.s2.d": "Executive Ford Sprinter vans to keep the wedding party together in comfort between venues.",
    "wed.s3.t": "Bridal party transportation",
    "wed.s3.d": "Coordinated pickups for the bridal party, family and VIPs so everyone arrives on time.",
    "wed.s4.t": "Guest & hotel shuttles",
    "wed.s4.d": "Continuous shuttle loops between hotels, ceremony and reception so no guest is stranded.",
    "wed.s5.t": "Ceremony & reception",
    "wed.s5.d": "Seamless transfers between ceremony, photos and reception on a schedule we manage for you.",
    "wed.s6.t": "Late-night return",
    "wed.s6.d": "Safe, comfortable late-night transportation to bring you and your guests home.",
    "wed.coord.title": "We coordinate every detail",
    "wed.coord.1": "Multiple pickup locations and passenger groups",
    "wed.coord.2": "Multiple vehicles working together on one timeline",
    "wed.coord.3": "A custom schedule built around your ceremony and reception",
    "wed.coord.4": "Rehearsal and morning-of transportation",
    "wed.coord.5": "Red-carpet arrival and special requests where available",
    "wed.coord.6": "A dedicated coordinator contact for your event day",
    "wed.faq.title": "Wedding & event questions",
    "wed.faq.q1": "How far in advance should we book?",
    "wed.faq.a1": "Weddings are best booked several weeks to a few months ahead, especially for peak-season weekends and multi-vehicle events. Earlier booking secures your preferred vehicles.",
    "wed.faq.q2": "Can you provide more than one vehicle?",
    "wed.faq.a2": "Yes — we regularly coordinate a limousine for the couple plus Ford Sprinters and guest shuttles, all on a single synchronized timeline.",
    "wed.faq.q3": "How does pricing work for weddings?",
    "wed.faq.a3": "Wedding and event transportation is arranged as a custom quote so we can tailor vehicles, hours and multiple pickups to your day. Submit your details and our team will follow up.",
    "wed.faq.q4": "Do you offer guest shuttles between hotels and the venue?",
    "wed.faq.a4": "Absolutely. We run continuous shuttle loops between hotels, the ceremony and the reception to keep your guests moving comfortably.",
    "wed.cta.title": "Let's plan your wedding transportation",
    "wed.cta.sub": "Tell us about your day and we'll build a custom quote and timeline.",
    "grp.eyebrow": "Group Transportation",
    "grp.title": "Group transportation for every occasion",
    "grp.subtitle": "Chauffeured Ford Sprinters, minibuses and charter buses for conferences, schools, sports teams, tours and large groups — across Montréal, Québec and Ontario.",
    "grp.who.title": "Who we move",
    "grp.a1.t": "Conferences & corporate",
    "grp.a1.d": "Reliable shuttles for conferences, trade shows and corporate events — multiple vehicles coordinated together.",
    "grp.a2.t": "Schools & universities",
    "grp.a2.d": "Field trips, competitions and student transportation with professional, vetted drivers.",
    "grp.a3.t": "Sports teams",
    "grp.a3.d": "Team and supporter transportation with room for equipment and luggage.",
    "grp.a4.t": "Tours & festivals",
    "grp.a4.d": "Multi-stop itineraries for tours, festivals and group travel across the region.",
    "grp.a5.t": "Hotels & travel agencies",
    "grp.a5.d": "Guest shuttles and partner arrangements for hotels and travel agencies.",
    "grp.a6.t": "Large groups & families",
    "grp.a6.d": "Reunions, religious organizations and large families travelling together.",
    "grp.cap.title": "Built for large groups",
    "grp.cap.1": "Minibuses and charter buses up to 33 passengers",
    "grp.cap.2": "Multiple vehicles coordinated for larger groups",
    "grp.cap.3": "Multiple pickup points and passenger manifests",
    "grp.cap.4": "Recurring schedules and return transportation",
    "grp.cap.5": "Long-distance and multi-day itineraries",
    "grp.cap.6": "Dedicated organizer contact and custom coordination",
    "grp.faq.title": "Group transportation questions",
    "grp.faq.q1": "What is the largest group you can handle?",
    "grp.faq.a1": "From minibuses to 33-passenger charter buses, plus multiple vehicles coordinated together for larger events.",
    "grp.faq.q2": "Do you handle recurring schedules and round trips?",
    "grp.faq.a2": "Yes — recurring shuttles, return transportation and multi-day itineraries are arranged through a custom quote.",
    "grp.faq.q3": "How does group pricing work?",
    "grp.faq.a3": "Group transportation is priced as a custom quote based on group size, route and schedule. Submit your details for a fast quote.",
    "grp.faq.q4": "Can you coordinate multiple vehicles for one event?",
    "grp.faq.a4": "Absolutely. We coordinate multiple vehicles on a single timeline, with a dedicated organizer contact for your event.",
    "grp.cta.title": "Let's plan your group transportation",
    "grp.cta.sub": "Tell us about your group and we'll build a custom quote.",
    "area.eyebrow": "Service Areas",
    "area.title": "Where we take you",
    "area.subtitle": "Based in Montréal, we serve all of Greater Montréal and offer long-distance transportation across Québec and Ontario.",
    "area.primary.title": "Our primary coverage",
    "area.p1": "Montréal",
    "area.p2": "Greater Montréal",
    "area.p3": "Laval",
    "area.p4": "Longueuil",
    "area.p5": "South Shore (Rive-Sud)",
    "area.p6": "North Shore (Rive-Nord)",
    "area.p7": "Montréal-Trudeau Airport (YUL)",
    "area.routes.title": "Long-distance routes",
    "area.note": "Long-distance and cross-border trips are arranged as a custom quote so we can tailor the vehicle, route and schedule to your journey.",
    "area.r1": "Montréal → Québec City",
    "area.r1.time": "~3 hrs",
    "area.r2": "Montréal → Ottawa",
    "area.r2.time": "~2 hrs",
    "area.r3": "Montréal → Toronto",
    "area.r3.time": "~5–6 hrs",
    "area.map.title": "Coverage map",
    "area.faq.title": "Service area questions",
    "area.faq.q1": "Do you serve my area?",
    "area.faq.a1": "We serve all of Greater Montréal, Laval, Longueuil, the South and North Shores, and YUL airport. Not sure? Call us or enter your trip and we'll confirm right away.",
    "area.faq.q2": "Do you travel outside Montréal?",
    "area.faq.a2": "Yes — we offer long-distance transportation to Québec City, Ottawa, Toronto and beyond, arranged through a custom quote.",
    "area.faq.q3": "Do you do cross-border trips?",
    "area.faq.a3": "Cross-border requests are reviewed case by case through our quote process. Contact us with your trip details and we'll advise.",
    "area.cta.title": "Don't see your destination?",
    "area.cta.sub": "Enter your trip or call us — we cover more ground than you might think.",
    "portal.eyebrow": "Customer Portal",
    "portal.title": "Manage your reservation",
    "portal.subtitle": "Enter your email and we'll send a secure link to view and manage your reservations — no password required.",
    "portal.email": "Email",
    "portal.sendLink": "Send secure link",
    "portal.sent": "Check your email",
    "portal.sentSub": "If any reservations exist for this email, a secure link has just been sent. It expires in 45 minutes.",
    "portal.expired": "This link has expired. Please request a new one.",
    "portal.yourBookings": "Your reservations",
    "portal.none": "No reservations found for this email.",
    "portal.paid": "Paid",
    "portal.depositPaid": "Deposit paid",
    "portal.unpaid": "Pending",
    "portal.flight.title": "Flight details",
    "portal.flight.number": "Flight number",
    "portal.flight.airline": "Airline",
    "portal.flight.terminal": "Terminal",
    "portal.contact.title": "Contact details",
    "portal.contact.phone": "Phone",
    "portal.contact.notes": "Special instructions",
    "portal.save": "Save",
    "portal.saved": "Saved",
    "portal.payBalance": "Pay balance ${amount}",
    "portal.addCalendar": "Add to calendar",
    "portal.reqMod": "Request a change",
    "portal.reqModDesc": "Describe the change you'd like (date, time, route, passengers). Our team will confirm it.",
    "portal.reqCancel": "Request cancellation",
    "portal.reqCancelDesc": "Request to cancel this reservation. Our team will follow up per the cancellation policy.",
    "portal.reqMsg": "Your message",
    "portal.reqSend": "Send request",
    "portal.reqSent": "Request sent",
    "nav.manageBooking": "Manage my booking",
    // Services
    "services.eyebrow": "Our Services",
    "services.title": "Curated for every occasion",
    "services.subtitle": "From black-tie affairs to unforgettable nights out, choose the experience that fits the moment.",
    "services.reserve": "Reserve",
    "svc.limousine.title": "Luxury Limousine",
    "svc.limousine.desc": "Arrive in refined elegance. Chauffeured stretch and executive limousines for weddings, galas and corporate travel.",
    "svc.party_bus.title": "Ford Sprinter",
    "svc.party_bus.desc": "Executive Ford Sprinter passenger vans for airport groups, corporate teams, weddings and tours. Seating for up to 13 with climate control and charging ports.",
    "svc.private_driver.title": "Private Chauffeur",
    "svc.private_driver.desc": "Your personal chauffeur in a Cadillac Escalade, on your schedule. Discreet, professional and always on time for airport, executive and VIP travel.",
    "svc.transit_bus.title": "Minibus & Charter Bus",
    "svc.transit_bus.desc": "Minibuses and charter buses for conferences, schools, sports teams and large groups — up to 33 passengers with luggage bays and preset routes across Québec and Ontario.",
    "svc.transit_bus.tag": "Preset routes",
    // Fleet
    "fleet.eyebrow": "The Fleet",
    "fleet.title": "Immaculate vehicles, impeccable detail",
    "fleet.escalade": "Cadillac Escalade",
    "fleet.escaladeSub": "Executive-class SUV chauffeur service",
    "fleet.interior": "Escalade Interior",
    "fleet.partyLounge": "Bus Lounges",
    // Process
    "process.eyebrow": "How It Works",
    "process.title": "Booked in three simple steps",
    "process.s1.title": "Choose your experience",
    "process.s1.desc": "Select a limousine, Ford Sprinter or private chauffeur that suits your occasion.",
    "process.s2.title": "Pick date & time",
    "process.s2.desc": "Use our calendar to lock in the exact moment your ride begins.",
    "process.s3.title": "Confirm & secure",
    "process.s3.desc": "Add your details, review the estimate, and secure your reservation with a deposit.",
    // CTA
    "cta.title": "Your evening deserves an entrance",
    "cta.subtitle": "Reserve your chauffeured experience with Autobus Limo Mont Royal today.",
    "cta.button": "Reserve Now",
    // Footer
    "footer.tagline": "Montreal's premier luxury transportation. Chauffeured limousines, Ford Sprinter vans and private chauffeurs for every occasion.",
    "footer.services": "Services",
    "footer.company": "Company",
    "footer.contact": "Contact",
    "footer.reserve": "Reserve",
    "footer.signin": "Sign In",
    "footer.ourFleet": "Our Fleet",
    "footer.airport": "Airport Transfers",
    "footer.rights": "All rights reserved.",
    "footer.popular": "Popular services & routes",
    "footer.admin": "Admin",
    // Booking
    "booking.title": "Reserve Your Ride",
    "booking.subtitle": "Complete the steps below to secure your chauffeured experience.",
    "booking.back": "Back",
    "booking.continue": "Continue",
    "booking.step.service": "Service",
    "booking.step.trip": "Trip Details",
    "booking.step.vehicle": "Vehicle",
    "booking.step.info": "Your Info",
    "booking.step.review": "Review",
    "booking.tripType": "Trip Type",
    "booking.tt.one_way": "One-way",
    "booking.tt.round_trip": "Round-trip",
    "booking.tt.hourly": "Hourly",
    "booking.tt.multi_day": "Multi-day",
    "booking.pickup": "Pickup Location",
    "booking.dropoff": "Drop-off Location",
    "booking.addressPlaceholder": "Search for an address, hotel, airport or place",
    "booking.passengers": "Passengers",
    "booking.luggage": "Luggage (bags)",
    "booking.flight": "Flight # (if airport)",
    "booking.hours": "Hours",
    "booking.time": "Pickup Time",
    "booking.selectTime": "Select time",
    "booking.selectDate": "Select Date",
    "booking.choosePackage": "Choose a Package",
    "booking.selectVehicle": "Select a Vehicle",
    "booking.instantAvailable": "Instant booking available",
    "booking.quoteRequired": "This trip requires a custom quote",
    "booking.available": "Available",
    "booking.unavailable": "Unavailable",
    "booking.noVehicles": "No vehicles configured for this service yet.",
    "booking.fullName": "Full Name",
    "booking.phone": "Phone",
    "booking.email": "Email",
    "booking.occasion": "Occasion",
    "booking.occasionPlaceholder": "Wedding, prom, night out...",
    "booking.leadSource": "How did you hear about us?",
    "booking.selectSource": "Select a source",
    "booking.requests": "Special Requests",
    "booking.requestsPlaceholder": "Champagne, decorations, music preferences...",
    "booking.review": "Review Reservation",
    "booking.estimate": "Estimate",
    "booking.selectService": "Select a service to see your estimate.",
    "booking.package": "Package",
    "booking.estimatedTrip": "Estimated Trip",
    "booking.minDrive": "min drive",
    "booking.subtotal": "Subtotal",
    "booking.tax": "Tax",
    "booking.gratuity": "Gratuity",
    "booking.total": "Total",
    "booking.depositNow": "Deposit due now",
    "booking.balanceLater": "Balance due later",
    "booking.startingFrom": "Starting from",
    "booking.selectVehicleHint": "Select a vehicle above to see your full price breakdown.",
    "booking.vehicleHeld": "Vehicle held for",
    "booking.customQuote": "Custom quote",
    "booking.customQuoteNote": "No payment now. Our team will review your trip and send a personalized quote with a secure deposit link.",
    "booking.priceOnRequest": "Price on request",
    "booking.priceOnRequestNote": "Our team will confirm pricing for this package and vehicle, then send you a secure deposit link.",
    "booking.confirmPay": "Confirm & Pay Deposit",
    "booking.requestQuote": "Request Quote",
    "booking.passengersLabel": "passengers",
    "booking.hoursLabel": "hours",
    "field.service": "Service",
    "field.vehicle": "Vehicle",
    "field.date": "Date",
    "field.time": "Time",
    "field.pickup": "Pickup",
    "field.dropoff": "Drop-off",
    "field.duration": "Duration",
    "field.name": "Name",
    "field.email": "Email",
    "field.phone": "Phone",
    "field.tripType": "Trip Type",
    "field.luggage": "Luggage",
    "field.flight": "Flight",
    "field.occasion": "Occasion",
    "field.package": "Package",
    "field.passengers": "Passengers",
    "booking.presetHint": "10 preset routes · quote on request",
    "ac.searching": "Searching…",
    "ac.noResults": "No locations found",
    "ac.recent": "Recent locations",
    "ac.selectSuggestion": "Please select a location from the suggestions.",
    "booking.addStop": "Add stop",
    "booking.stopLabel": "Stop",
    "booking.stopPlaceholder": "Search a stop location",
    "booking.invalidPickup": "Please select a pickup from the suggestions.",
    "booking.invalidDropoff": "Please select a drop-off from the suggestions.",
    // Auth
    "auth.backHome": "Back home",
    "auth.welcome": "Welcome back",
    "auth.signinSub": "Sign in to manage your reservations.",
    "auth.google": "Continue with Google",
    "auth.or": "or",
    "auth.password": "Password",
    "auth.signin": "Sign In",
    "auth.noAccount": "No account?",
    "auth.createOne": "Create one",
    "auth.createAccount": "Create account",
    "auth.createSub": "Book faster and track your rides.",
    "auth.createBtn": "Create Account",
    "auth.haveAccount": "Already have an account?",
    "auth.signinLink": "Sign in",
    // Account
    "account.welcome": "Welcome back",
    "account.newBooking": "New Reservation",
    "account.yourReservations": "Your Reservations",
    "account.empty": "You haven't made any reservations yet.",
    "account.first": "Reserve Your First Ride",
    "account.depositPaid": "Deposit Paid",
    "account.quoteRequested": "Quote Requested",
    "account.priceOnRequest": "Price on request",
    "account.deposit": "Deposit",
    // Booking detail / success
    "detail.confirmed": "Reservation Confirmed",
    "detail.received": "Reservation Received",
    "detail.secure": "Secure Your Reservation",
    "detail.reference": "Reference",
    "detail.payment": "Payment",
    "detail.quoteRequested": "Quote requested",
    "detail.quoteNote": "Our team will confirm pricing for your {vehicle} and send you a secure deposit link shortly.",
    "detail.estimatedTotal": "Estimated total",
    "detail.deposit": "Deposit (25%)",
    "detail.dueToday": "Due today",
    "detail.depositPaidBadge": "Deposit paid",
    "detail.payDeposit": "Pay ${amount} Deposit",
    "detail.addCalendar": "Add to Google Calendar",
    "detail.myReservations": "View my reservations",
    "detail.notFound": "Reservation not found",
    "detail.newReservation": "New Reservation",
    "detail.passengers": "passengers",
    "success.confirming": "Confirming your payment",
    "success.wait": "Please wait a moment...",
    "success.confirmed": "Reservation Confirmed",
    "success.confirmedNote": "Your deposit has been received. Our team will be in touch shortly to finalize the details of your ride.",
    "success.myReservations": "My Reservations",
    "success.home": "Home",
    "success.failed": "Payment not completed",
    "success.failedNote": "We couldn't confirm your payment. You can try again from your reservation.",
    "success.viewReservations": "View Reservations",
  },
  fr: {
    "nav.services": "Services",
    "nav.fleet": "Flotte",
    "nav.process": "Comment ça marche",
    "nav.contact": "Contact",
    "nav.signin": "Se connecter",
    "nav.reserve": "Réserver",
    "nav.dashboard": "Tableau de bord",
    "nav.account": "Compte",
    "nav.myAccount": "Mon compte",
    "nav.signout": "Se déconnecter",
    "hero.eyebrow": "Montréal · Transport de luxe avec chauffeur",
    "hero.title": "Transport privé et de groupe de prestige à Montréal",
    "hero.subtitle": "Réservez un chauffeur privé, une limousine, un Ford Sprinter, un minibus ou un autocar pour vos transferts aéroportuaires, déplacements d'affaires, mariages, événements et transport de groupe.",
    "hero.cta": "Réservez votre trajet",
    "hero.fleet": "Découvrir la flotte",
    "hero.licensed": "Licencié et assuré",
    "hero.available": "Disponible 24/7",
    "hero.rated": "Chauffeurs 5 étoiles",
    "hero.call": "Appelez 24/7",
    "hero.phone": "438-470-1138",
    "widget.title": "Obtenir une soumission instantanée",
    "widget.tripType": "Type de trajet",
    "widget.pickup": "Lieu de prise en charge",
    "widget.dropoff": "Destination",
    "widget.date": "Date de départ",
    "widget.time": "Heure de départ",
    "widget.passengers": "Passagers",
    "widget.service": "Service / véhicule",
    "widget.anyService": "Tout service",
    "widget.submit": "Voir véhicules et tarifs",
    "trust.licensed": "Licencié et assuré",
    "trust.chauffeurs": "Chauffeurs professionnels",
    "trust.support": "Réservation 24/7",
    "trust.flight": "Suivi des vols",
    "trust.secure": "Paiements en ligne sécurisés",
    "trust.montreal": "Service basé à Montréal",
    "cat.eyebrow": "Nos services",
    "cat.title": "Une entreprise pour tous vos besoins de transport",
    "cat.subtitle": "Du service de chauffeur privé au transport de grands groupes, partout à Montréal et au Québec.",
    "cat.for": "Idéal pour",
    "cat.private_driver.for": "Affaires · Aéroport · Corporatif · VIP",
    "cat.limousine.for": "Mariages · Bals · Anniversaires · Célébrations",
    "cat.party_bus.for": "Groupes à l'aéroport · Équipes corporatives · Tours · Équipes sportives",
    "cat.transit_bus.for": "Congrès · Écoles · Grands groupes · Longue distance",
    "cat.book": "Réserver",
    "cat.quote": "Demander une soumission",
    "cat.capacity": "Jusqu'à {n} passagers",
    "cat.instant": "Réservation instantanée",
    "cat.quoteOnly": "Soumission personnalisée",
    "pos.title": "Une entreprise de transport de prestige pour tout",
    "pos.subtitle": "Du service de chauffeur privé au transport de grands groupes — réservé, payé et confirmé en ligne en quelques minutes.",
    "faq.eyebrow": "FAQ",
    "faq.title": "Questions fréquentes",
    "faq.q1": "Quels secteurs desservez-vous?",
    "faq.a1": "Nous sommes basés à Montréal et desservons le Grand Montréal, Laval, Longueuil, les Rives-Sud et Nord ainsi que l'aéroport Montréal-Trudeau (YUL). Les trajets longue distance vers Québec, Ottawa et Toronto sont offerts sur demande.",
    "faq.q2": "Comment obtenir un prix?",
    "faq.a2": "Entrez votre trajet dans le formulaire pour voir instantanément les véhicules disponibles et les tarifs. Les demandes de groupe et d'autocar sont transmises à notre équipe pour une soumission personnalisée en quelques heures.",
    "faq.q3": "Suivez-vous les vols pour les prises en charge à l'aéroport?",
    "faq.a3": "Oui. Pour les transferts aéroportuaires, nous suivons votre vol et ajustons l'heure de prise en charge en cas de retard ou d'arrivée anticipée, avec temps d'attente gratuit.",
    "faq.q4": "Comment fonctionnent les dépôts et les paiements?",
    "faq.a4": "Les réservations instantanées sont confirmées par un dépôt sécurisé en ligne. Le solde est dû avant ou le jour du service. La facturation corporative est offerte aux comptes approuvés.",
    "faq.q5": "Pouvez-vous gérer les mariages et grands événements de groupe?",
    "faq.a5": "Absolument. Nous coordonnons plusieurs véhicules, plusieurs points de prise en charge et des horaires personnalisés pour mariages, congrès, écoles et équipes sportives. Demandez une soumission et notre équipe bâtira votre itinéraire.",
    "nav.airport": "Transferts aéroport",
    "nav.corporate": "Corporatif",
    "nav.weddings": "Mariages et événements",
    "nav.groups": "Transport de groupe",
    "nav.areas": "Zones desservies",
    "nav.about": "À propos",
    "nav.getQuote": "Obtenir une soumission",
    "nav.airportShort": "Aéroport",
    "nav.weddingsShort": "Mariages",
    "nav.groupsShort": "Groupes",
    "nav.call": "Appeler",
    "air.eyebrow": "Transferts aéroport · YUL",
    "air.title": "Transferts vers l'aéroport Montréal-Trudeau, bien faits",
    "air.subtitle": "Chauffeur privé, Ford Sprinter et transport de groupe vers et depuis Montréal-Trudeau (YUL) — avec suivi des vols, accueil personnalisé et temps d'attente gratuit.",
    "air.inc.title": "Chaque transfert aéroportuaire comprend",
    "air.inc.flight.t": "Suivi des vols",
    "air.inc.flight.d": "Nous suivons votre vol et ajustons automatiquement la prise en charge en cas de retard ou d'arrivée anticipée.",
    "air.inc.greet.t": "Accueil personnalisé",
    "air.inc.greet.d": "Votre chauffeur vous accueille dans l'aérogare avec une pancarte à votre nom et vous aide avec les bagages.",
    "air.inc.wait.t": "Attente gratuite",
    "air.inc.wait.d": "Temps d'attente inclus après l'atterrissage — vous n'êtes jamais pressé.",
    "air.inc.luggage.t": "Aide aux bagages",
    "air.inc.luggage.d": "Grande capacité de bagages et service porte-à-porte pour vous et votre groupe.",
    "air.inc.fixed.t": "Tarification transparente",
    "air.inc.fixed.d": "Prix aéroport clair à l'avance — sans majoration ni surprise.",
    "air.inc.child.t": "Sièges pour enfants sur demande",
    "air.inc.child.d": "Sièges pour bébé et rehausseurs disponibles — ajoutez-les à votre réservation.",
    "air.how.title": "Comment fonctionnent les transferts",
    "air.how.s1.t": "Entrez votre vol",
    "air.how.s1.d": "Ajoutez votre numéro de vol, l'aérogare et le nombre de passagers à la réservation.",
    "air.how.s2.t": "Nous suivons et répartissons",
    "air.how.s2.d": "Nous surveillons votre vol et envoyons votre chauffeur au bon moment.",
    "air.how.s3.t": "Accueil et départ",
    "air.how.s3.d": "Votre chauffeur vous accueille, s'occupe des bagages et vous conduit porte-à-porte.",
    "air.faq.title": "Questions sur les transferts aéroport",
    "air.faq.q1": "Que se passe-t-il si mon vol est retardé?",
    "air.faq.a1": "Nous suivons votre vol en temps réel et ajustons automatiquement votre prise en charge sans frais, avec temps d'attente gratuit inclus.",
    "air.faq.q2": "Où mon chauffeur me rencontrera-t-il?",
    "air.faq.a2": "À l'arrivée, votre chauffeur vous accueille dans l'aérogare avec une pancarte à votre nom. Les instructions exactes sont confirmées avant votre trajet.",
    "air.faq.q3": "Pouvez-vous gérer des groupes arrivant sur le même vol?",
    "air.faq.a3": "Oui — nous coordonnons des Ford Sprinter et des autocars pour des groupes jusqu'à 33 passagers arrivant ensemble. Demandez une soumission pour les transferts de groupe.",
    "air.faq.q4": "Desservez-vous d'autres aéroports que YUL?",
    "air.faq.a4": "Montréal-Trudeau (YUL) est notre aéroport principal. Les transferts vers d'autres aéroports et destinations longue distance sont offerts sur demande.",
    "air.cta.title": "Réservez votre transfert aéroport",
    "air.cta.sub": "Réservez un chauffeur privé ou demandez une soumission de groupe en quelques minutes.",
    "corp.eyebrow": "Transport corporatif",
    "corp.title": "Le transport d'affaires, géré avec précision",
    "corp.subtitle": "Un partenaire fiable pour les déplacements d'affaires, transferts aéroport, roadshows et transport de groupe — avec facturation centralisée et répartition prioritaire pour votre équipe.",
    "corp.cta": "Ouvrir un compte corporatif",
    "corp.benefits.title": "Conçu pour les équipes qui voyagent",
    "corp.b1.t": "Facturation centralisée",
    "corp.b1.d": "Regroupez chaque trajet sur une seule facture mensuelle avec ventilation par centre de coûts.",
    "corp.b2.t": "Facturation mensuelle",
    "corp.b2.d": "Modalités flexibles et relevés mensuels plutôt qu'un paiement à chaque trajet.",
    "corp.b3.t": "Plusieurs demandeurs",
    "corp.b3.d": "Autorisez adjoints et membres de l'équipe à réserver sur le compte de l'entreprise.",
    "corp.b4.t": "Répartition prioritaire",
    "corp.b4.d": "Vos réservations sont prioritaires — vos dirigeants n'attendent jamais.",
    "corp.b5.t": "Coordination congrès et roadshows",
    "corp.b5.d": "Logistique multi-véhicules pour congrès, roadshows et événements corporatifs.",
    "corp.b6.t": "Rapports de déplacements",
    "corp.b6.d": "Rapports détaillés et passagers, trajets et centres de coûts enregistrés.",
    "corp.form.title": "Ouvrir un compte corporatif",
    "corp.form.sub": "Parlez-nous de votre équipe et notre gestion de comptes vous contactera d'ici un jour ouvrable.",
    "corp.form.company": "Nom de l'entreprise",
    "corp.form.contact": "Personne-ressource",
    "corp.form.employees": "Équipe / trajets mensuels approx.",
    "corp.form.message": "Comment pouvons-nous aider?",
    "corp.form.submit": "Demander un compte corporatif",
    "corp.form.success": "Demande reçue",
    "corp.form.successSub": "Merci — notre équipe des comptes corporatifs vous contactera sous peu.",
    "wed.eyebrow": "Mariages et événements",
    "wed.title": "Transport de mariage et d'événement, coordonné avec soin",
    "wed.subtitle": "Limousines, Ford Sprinter et navettes d'invités pour mariages, galas et célébrations privées à Montréal — avec coordination multi-véhicules et un horaire conçu autour de votre journée.",
    "wed.svc.title": "Services de transport pour mariages et événements",
    "wed.s1.t": "Limousine de mariage",
    "wed.s1.d": "Une limousine avec chauffeur pour les mariés — entrées remarquées, photos et trajet vers la réception.",
    "wed.s2.t": "Transport Ford Sprinter",
    "wed.s2.d": "Fourgonnettes Ford Sprinter exécutives pour garder le cortège ensemble et confortable entre les lieux.",
    "wed.s3.t": "Transport du cortège",
    "wed.s3.d": "Prises en charge coordonnées pour le cortège, la famille et les VIP afin que tout le monde arrive à l'heure.",
    "wed.s4.t": "Navettes d'invités et d'hôtel",
    "wed.s4.d": "Navettes continues entre les hôtels, la cérémonie et la réception pour qu'aucun invité ne soit laissé pour compte.",
    "wed.s5.t": "Cérémonie et réception",
    "wed.s5.d": "Transferts fluides entre cérémonie, photos et réception selon un horaire que nous gérons pour vous.",
    "wed.s6.t": "Retour en fin de soirée",
    "wed.s6.d": "Transport sécuritaire et confortable en fin de soirée pour vous ramener, vous et vos invités.",
    "wed.coord.title": "Nous coordonnons chaque détail",
    "wed.coord.1": "Plusieurs lieux de prise en charge et groupes de passagers",
    "wed.coord.2": "Plusieurs véhicules travaillant ensemble sur un même horaire",
    "wed.coord.3": "Un horaire sur mesure autour de votre cérémonie et réception",
    "wed.coord.4": "Transport pour la répétition et le matin même",
    "wed.coord.5": "Arrivée tapis rouge et demandes spéciales selon disponibilité",
    "wed.coord.6": "Une personne-ressource dédiée pour le jour de votre événement",
    "wed.faq.title": "Questions sur les mariages et événements",
    "wed.faq.q1": "Combien de temps à l'avance réserver?",
    "wed.faq.a1": "Il est préférable de réserver les mariages plusieurs semaines à quelques mois à l'avance, surtout pour les fins de semaine de haute saison et les événements multi-véhicules. Réserver tôt garantit vos véhicules préférés.",
    "wed.faq.q2": "Pouvez-vous fournir plus d'un véhicule?",
    "wed.faq.a2": "Oui — nous coordonnons régulièrement une limousine pour les mariés ainsi que des Ford Sprinter et navettes d'invités, le tout sur un horaire synchronisé.",
    "wed.faq.q3": "Comment fonctionne la tarification pour les mariages?",
    "wed.faq.a3": "Le transport de mariage et d'événement est offert sur soumission afin d'adapter véhicules, heures et prises en charge multiples à votre journée. Soumettez vos détails et notre équipe fera un suivi.",
    "wed.faq.q4": "Offrez-vous des navettes d'invités entre les hôtels et le lieu?",
    "wed.faq.a4": "Absolument. Nous effectuons des navettes continues entre les hôtels, la cérémonie et la réception pour garder vos invités confortablement en mouvement.",
    "wed.cta.title": "Planifions le transport de votre mariage",
    "wed.cta.sub": "Parlez-nous de votre journée et nous bâtirons une soumission et un horaire sur mesure.",
    "grp.eyebrow": "Transport de groupe",
    "grp.title": "Transport de groupe pour chaque occasion",
    "grp.subtitle": "Ford Sprinter, minibus et autocars avec chauffeur pour congrès, écoles, équipes sportives, tours et grands groupes — partout à Montréal, au Québec et en Ontario.",
    "grp.who.title": "Pour qui nous transportons",
    "grp.a1.t": "Congrès et corporatif",
    "grp.a1.d": "Navettes fiables pour congrès, salons et événements corporatifs — plusieurs véhicules coordonnés.",
    "grp.a2.t": "Écoles et universités",
    "grp.a2.d": "Sorties éducatives, compétitions et transport étudiant avec chauffeurs professionnels.",
    "grp.a3.t": "Équipes sportives",
    "grp.a3.d": "Transport d'équipes et de partisans avec espace pour l'équipement et les bagages.",
    "grp.a4.t": "Tours et festivals",
    "grp.a4.d": "Itinéraires à plusieurs arrêts pour tours, festivals et voyages de groupe.",
    "grp.a5.t": "Hôtels et agences de voyage",
    "grp.a5.d": "Navettes d'invités et forfaits partenaires pour hôtels et agences de voyage.",
    "grp.a6.t": "Grands groupes et familles",
    "grp.a6.d": "Retrouvailles, groupes religieux et grandes familles voyageant ensemble.",
    "grp.cap.title": "Conçu pour les grands groupes",
    "grp.cap.1": "Minibus et autocars jusqu'à 33 passagers",
    "grp.cap.2": "Plusieurs véhicules coordonnés pour les grands groupes",
    "grp.cap.3": "Plusieurs points de prise en charge et manifestes de passagers",
    "grp.cap.4": "Horaires récurrents et transport aller-retour",
    "grp.cap.5": "Itinéraires longue distance et de plusieurs jours",
    "grp.cap.6": "Contact organisateur dédié et coordination sur mesure",
    "grp.faq.title": "Questions sur le transport de groupe",
    "grp.faq.q1": "Quelle est la taille maximale des groupes?",
    "grp.faq.a1": "Du minibus aux autocars de 33 passagers, et plusieurs véhicules coordonnés ensemble pour les événements plus importants.",
    "grp.faq.q2": "Gérez-vous les horaires récurrents et les allers-retours?",
    "grp.faq.a2": "Oui — navettes récurrentes, transport aller-retour et itinéraires de plusieurs jours sont organisés par soumission.",
    "grp.faq.q3": "Comment fonctionne la tarification de groupe?",
    "grp.faq.a3": "Le transport de groupe est offert sur soumission selon la taille du groupe, la route et l'horaire. Soumettez vos détails pour un prix rapide.",
    "grp.faq.q4": "Pouvez-vous coordonner plusieurs véhicules pour un seul événement?",
    "portal.eyebrow": "Espace client",
    "portal.title": "Gérez votre réservation",
    "portal.subtitle": "Entrez votre courriel et nous vous enverrons un lien sécurisé pour consulter et gérer vos réservations — aucun mot de passe requis.",
    "portal.email": "Courriel",
    "portal.sendLink": "Envoyer le lien sécurisé",
    "portal.sent": "Vérifiez votre courriel",
    "portal.sentSub": "Si des réservations existent pour ce courriel, un lien sécurisé vient d'être envoyé. Il expire dans 45 minutes.",
    "portal.expired": "Ce lien a expiré. Veuillez en demander un nouveau.",
    "portal.yourBookings": "Vos réservations",
    "portal.none": "Aucune réservation trouvée pour ce courriel.",
    "portal.paid": "Payé",
    "portal.depositPaid": "Dépôt payé",
    "portal.unpaid": "En attente",
    "portal.flight.title": "Détails du vol",
    "portal.flight.number": "Numéro de vol",
    "portal.flight.airline": "Compagnie",
    "portal.flight.terminal": "Aérogare",
    "portal.contact.title": "Coordonnées",
    "portal.contact.phone": "Téléphone",
    "portal.contact.notes": "Instructions spéciales",
    "portal.save": "Enregistrer",
    "portal.saved": "Enregistré",
    "portal.payBalance": "Payer le solde ${amount}",
    "portal.addCalendar": "Ajouter au calendrier",
    "portal.reqMod": "Demander une modification",
    "portal.reqModDesc": "Décrivez le changement souhaité (date, heure, trajet, passagers). Notre équipe le confirmera.",
    "portal.reqCancel": "Demander une annulation",
    "portal.reqCancelDesc": "Demandez l'annulation de cette réservation. Notre équipe fera un suivi selon la politique d'annulation.",
    "portal.reqMsg": "Votre message",
    "portal.reqSend": "Envoyer la demande",
    "portal.reqSent": "Demande envoyée",
    "nav.manageBooking": "Gérer ma réservation",
    "grp.faq.a4": "Absolument. Nous coordonnons plusieurs véhicules sur un même horaire, avec un contact organisateur dédié pour votre événement.",
    "grp.cta.title": "Planifions votre transport de groupe",
    "grp.cta.sub": "Parlez-nous de votre groupe et nous bâtirons une soumission sur mesure.",
    "area.eyebrow": "Zones desservies",
    "area.title": "Où nous vous conduisons",
    "area.subtitle": "Basés à Montréal, nous desservons tout le Grand Montréal et offrons des trajets longue distance à travers le Québec et l'Ontario.",
    "area.primary.title": "Notre secteur principal",
    "area.p1": "Montréal",
    "area.p2": "Grand Montréal",
    "area.p3": "Laval",
    "area.p4": "Longueuil",
    "area.p5": "Rive-Sud",
    "area.p6": "Rive-Nord",
    "area.p7": "Aéroport Montréal-Trudeau (YUL)",
    "area.routes.title": "Trajets longue distance",
    "area.note": "Les trajets longue distance et transfrontaliers sont offerts sur soumission afin d'adapter le véhicule, la route et l'horaire à votre voyage.",
    "area.r1": "Montréal → Québec",
    "area.r1.time": "~3 h",
    "area.r2": "Montréal → Ottawa",
    "area.r2.time": "~2 h",
    "area.r3": "Montréal → Toronto",
    "area.r3.time": "~5–6 h",
    "area.map.title": "Carte de couverture",
    "area.faq.title": "Questions sur les zones desservies",
    "area.faq.q1": "Desservez-vous ma région?",
    "area.faq.a1": "Nous desservons tout le Grand Montréal, Laval, Longueuil, les Rives-Sud et Nord ainsi que l'aéroport YUL. Vous n'êtes pas certain? Appelez-nous ou entrez votre trajet et nous confirmerons.",
    "area.faq.q2": "Allez-vous à l'extérieur de Montréal?",
    "area.faq.a2": "Oui — nous offrons des trajets longue distance vers Québec, Ottawa, Toronto et au-delà, organisés par soumission.",
    "area.faq.q3": "Faites-vous les trajets transfrontaliers?",
    "area.faq.a3": "Les demandes transfrontalières sont évaluées au cas par cas via notre processus de soumission. Contactez-nous avec les détails de votre voyage.",
    "area.cta.title": "Vous ne voyez pas votre destination?",
    "area.cta.sub": "Entrez votre trajet ou appelez-nous — nous couvrons plus de territoire que vous ne le pensez.",
    "services.eyebrow": "Nos services",
    "services.title": "Conçus pour chaque occasion",
    "services.subtitle": "Des soirées de gala aux sorties inoubliables, choisissez l'expérience qui convient au moment.",
    "services.reserve": "Réserver",
    "svc.limousine.title": "Limousine de luxe",
    "svc.limousine.desc": "Arrivez avec une élégance raffinée. Limousines allongées et exécutives avec chauffeur pour mariages, galas et déplacements d'affaires.",
    "svc.party_bus.title": "Ford Sprinter",
    "svc.party_bus.desc": "Fourgonnettes Ford Sprinter exécutives pour groupes à l'aéroport, équipes corporatives, mariages et tours. Jusqu'à 13 places avec climatisation et ports de recharge.",
    "svc.private_driver.title": "Chauffeur privé",
    "svc.private_driver.desc": "Votre chauffeur personnel dans un Cadillac Escalade, selon votre horaire. Discret, professionnel et toujours à l'heure pour l'aéroport, les affaires et les déplacements VIP.",
    "svc.transit_bus.title": "Minibus et autocar",
    "svc.transit_bus.desc": "Minibus et autocars pour congrès, écoles, équipes sportives et grands groupes — jusqu'à 33 passagers avec soutes à bagages et trajets prédéfinis au Québec et en Ontario.",
    "svc.transit_bus.tag": "Trajets prédéfinis",
    "fleet.eyebrow": "La flotte",
    "fleet.title": "Véhicules impeccables, souci du détail",
    "fleet.escalade": "Cadillac Escalade",
    "fleet.escaladeSub": "Service de chauffeur en VUS classe exécutive",
    "fleet.interior": "Intérieur Escalade",
    "fleet.partyLounge": "Salons d'autobus",
    "process.eyebrow": "Comment ça marche",
    "process.title": "Réservé en trois étapes simples",
    "process.s1.title": "Choisissez votre expérience",
    "process.s1.desc": "Sélectionnez une limousine, un Ford Sprinter ou un chauffeur privé adapté à votre occasion.",
    "process.s2.title": "Choisissez la date et l'heure",
    "process.s2.desc": "Utilisez notre calendrier pour fixer le moment exact du départ.",
    "process.s3.title": "Confirmez et sécurisez",
    "process.s3.desc": "Ajoutez vos détails, révisez l'estimation et sécurisez votre réservation avec un dépôt.",
    "cta.title": "Votre soirée mérite une entrée remarquée",
    "cta.subtitle": "Réservez votre expérience avec chauffeur chez Autobus Limo Mont Royal dès aujourd'hui.",
    "cta.button": "Réserver",
    "footer.tagline": "Le transport de luxe par excellence à Montréal. Limousines, Ford Sprinter et chauffeurs privés pour toutes les occasions.",
    "footer.services": "Services",
    "footer.company": "Entreprise",
    "footer.contact": "Contact",
    "footer.reserve": "Réserver",
    "footer.signin": "Se connecter",
    "footer.ourFleet": "Notre flotte",
    "footer.airport": "Transferts aéroport",
    "footer.rights": "Tous droits réservés.",
    "footer.popular": "Services et trajets populaires",
    "footer.admin": "Admin",
    "booking.title": "Réservez votre trajet",
    "booking.subtitle": "Complétez les étapes ci-dessous pour sécuriser votre expérience avec chauffeur.",
    "booking.back": "Retour",
    "booking.continue": "Continuer",
    "booking.step.service": "Service",
    "booking.step.trip": "Détails du trajet",
    "booking.step.vehicle": "Véhicule",
    "booking.step.info": "Vos infos",
    "booking.step.review": "Révision",
    "booking.tripType": "Type de trajet",
    "booking.tt.one_way": "Aller simple",
    "booking.tt.round_trip": "Aller-retour",
    "booking.tt.hourly": "À l'heure",
    "booking.tt.multi_day": "Plusieurs jours",
    "booking.pickup": "Lieu de prise en charge",
    "booking.dropoff": "Destination",
    "booking.addressPlaceholder": "Rechercher une adresse, un hôtel, un aéroport ou un lieu",
    "booking.passengers": "Passagers",
    "booking.luggage": "Bagages (valises)",
    "booking.flight": "N° de vol (si aéroport)",
    "booking.hours": "Heures",
    "booking.time": "Heure de départ",
    "booking.selectTime": "Choisir l'heure",
    "booking.selectDate": "Choisir la date",
    "booking.choosePackage": "Choisir un forfait",
    "booking.selectVehicle": "Choisir un véhicule",
    "booking.instantAvailable": "Réservation instantanée disponible",
    "booking.quoteRequired": "Ce trajet nécessite une soumission personnalisée",
    "booking.available": "Disponible",
    "booking.unavailable": "Indisponible",
    "booking.noVehicles": "Aucun véhicule configuré pour ce service pour l'instant.",
    "booking.fullName": "Nom complet",
    "booking.phone": "Téléphone",
    "booking.email": "Courriel",
    "booking.occasion": "Occasion",
    "booking.occasionPlaceholder": "Mariage, bal, sortie...",
    "booking.leadSource": "Comment nous avez-vous connus?",
    "booking.selectSource": "Choisir une source",
    "booking.requests": "Demandes spéciales",
    "booking.requestsPlaceholder": "Champagne, décorations, préférences musicales...",
    "booking.review": "Réviser la réservation",
    "booking.estimate": "Estimation",
    "booking.selectService": "Sélectionnez un service pour voir votre estimation.",
    "booking.package": "Forfait",
    "booking.estimatedTrip": "Trajet estimé",
    "booking.minDrive": "min de route",
    "booking.subtotal": "Sous-total",
    "booking.tax": "Taxes",
    "booking.gratuity": "Pourboire",
    "booking.total": "Total",
    "booking.depositNow": "Dépôt à payer maintenant",
    "booking.balanceLater": "Solde à payer plus tard",
    "booking.startingFrom": "À partir de",
    "booking.selectVehicleHint": "Sélectionnez un véhicule ci-dessus pour voir le détail du prix.",
    "booking.vehicleHeld": "Véhicule réservé pour",
    "booking.customQuote": "Soumission personnalisée",
    "booking.customQuoteNote": "Aucun paiement maintenant. Notre équipe examinera votre trajet et vous enverra une soumission personnalisée avec un lien de dépôt sécurisé.",
    "booking.priceOnRequest": "Prix sur demande",
    "booking.priceOnRequestNote": "Notre équipe confirmera le prix pour ce forfait et ce véhicule, puis vous enverra un lien de dépôt sécurisé.",
    "booking.confirmPay": "Confirmer et payer le dépôt",
    "booking.requestQuote": "Demander une soumission",
    "booking.passengersLabel": "passagers",
    "booking.hoursLabel": "heures",
    "field.service": "Service",
    "field.vehicle": "Véhicule",
    "field.date": "Date",
    "field.time": "Heure",
    "field.pickup": "Prise en charge",
    "field.dropoff": "Dépose",
    "field.duration": "Durée",
    "field.name": "Nom",
    "field.email": "Courriel",
    "field.phone": "Téléphone",
    "field.tripType": "Type de trajet",
    "field.luggage": "Bagages",
    "field.flight": "Vol",
    "field.occasion": "Occasion",
    "field.package": "Forfait",
    "field.passengers": "Passagers",
    "booking.presetHint": "10 trajets prédéfinis · sur devis",
    "ac.searching": "Recherche…",
    "ac.noResults": "Aucun lieu trouvé",
    "ac.recent": "Lieux récents",
    "ac.selectSuggestion": "Veuillez sélectionner un lieu parmi les suggestions.",
    "booking.addStop": "Ajouter un arrêt",
    "booking.stopLabel": "Arrêt",
    "booking.stopPlaceholder": "Rechercher un lieu d'arrêt",
    "booking.invalidPickup": "Veuillez sélectionner un lieu de prise en charge parmi les suggestions.",
    "booking.invalidDropoff": "Veuillez sélectionner une destination parmi les suggestions.",
    "auth.backHome": "Retour à l'accueil",
    "auth.welcome": "Bon retour",
    "auth.signinSub": "Connectez-vous pour gérer vos réservations.",
    "auth.google": "Continuer avec Google",
    "auth.or": "ou",
    "auth.password": "Mot de passe",
    "auth.signin": "Se connecter",
    "auth.noAccount": "Pas de compte?",
    "auth.createOne": "Créer un compte",
    "auth.createAccount": "Créer un compte",
    "auth.createSub": "Réservez plus vite et suivez vos trajets.",
    "auth.createBtn": "Créer un compte",
    "auth.haveAccount": "Vous avez déjà un compte?",
    "auth.signinLink": "Se connecter",
    "account.welcome": "Bon retour",
    "account.newBooking": "Nouvelle réservation",
    "account.yourReservations": "Vos réservations",
    "account.empty": "Vous n'avez encore fait aucune réservation.",
    "account.first": "Réservez votre premier trajet",
    "account.depositPaid": "Dépôt payé",
    "account.quoteRequested": "Soumission demandée",
    "account.priceOnRequest": "Prix sur demande",
    "account.deposit": "Dépôt",
    "detail.confirmed": "Réservation confirmée",
    "detail.received": "Réservation reçue",
    "detail.secure": "Sécurisez votre réservation",
    "detail.reference": "Référence",
    "detail.payment": "Paiement",
    "detail.quoteRequested": "Soumission demandée",
    "detail.quoteNote": "Notre équipe confirmera le prix pour votre {vehicle} et vous enverra sous peu un lien de dépôt sécurisé.",
    "detail.estimatedTotal": "Total estimé",
    "detail.deposit": "Dépôt (25%)",
    "detail.dueToday": "À payer aujourd'hui",
    "detail.depositPaidBadge": "Dépôt payé",
    "detail.payDeposit": "Payer le dépôt de {amount}$",
    "detail.addCalendar": "Ajouter à Google Agenda",
    "detail.myReservations": "Voir mes réservations",
    "detail.notFound": "Réservation introuvable",
    "detail.newReservation": "Nouvelle réservation",
    "detail.passengers": "passagers",
    "success.confirming": "Confirmation de votre paiement",
    "success.wait": "Veuillez patienter un instant...",
    "success.confirmed": "Réservation confirmée",
    "success.confirmedNote": "Votre dépôt a été reçu. Notre équipe vous contactera sous peu pour finaliser les détails de votre trajet.",
    "success.myReservations": "Mes réservations",
    "success.home": "Accueil",
    "success.failed": "Paiement non complété",
    "success.failedNote": "Nous n'avons pas pu confirmer votre paiement. Vous pouvez réessayer depuis votre réservation.",
    "success.viewReservations": "Voir les réservations",
  },
};
